import cn from 'clsx'

import React, { Component } from 'react'
import type { DropdownOption } from 'types/ui'
import ChannelSelector from 'components/common/channel-selector'
import FilterRow from '../filter-row'
type Props = {
  updateSearchParams: (...args: Array<any>) => any
  groups: Array<number>
  searchGroups: Array<Record<string, any>>
  searchGroupsIndexed?: (...args: Array<any>) => any
  baseSearchGroups: Array<Record<string, any>>
  showAllSearchGroups?: boolean
  toggleMore: (...args: Array<any>) => any
  isPhone?: boolean
  scrollContainer?: any
  disabled?: boolean
}
export default class Groups extends Component<Props> {
  _handleAllClick: () => any = () =>
    this.props.updateSearchParams({
      groups: [],
    })

  _handleGroupClick(id: number) {
    const { groups } = this.props
    let newGroups
    const groupId = groups.indexOf(id)

    if (groupId === -1) {
      newGroups = [...groups, id]
    } else {
      newGroups = [...groups.slice(0, groupId), ...groups.slice(groupId + 1)]
    }

    this.props.updateSearchParams({
      groups: newGroups,
    })
  }

  render(): React.ReactNode {
    const { groups, showAllSearchGroups, searchGroups, baseSearchGroups } =
      this.props
    const allActive = !groups.length ? ' is-active' : ''
    let additionalLink = null

    if (!showAllSearchGroups && searchGroups.length > baseSearchGroups.length) {
      additionalLink = (
        <a
          className="SearchResults_FilterOption_Toggle"
          onClick={this.props.toggleMore}
        >
          More...
        </a>
      )
    } else if (
      showAllSearchGroups &&
      searchGroups.length > baseSearchGroups.length
    ) {
      additionalLink = (
        <a
          className="SearchResults_FilterOption_Toggle"
          onClick={this.props.toggleMore}
        >
          Less...
        </a>
      )
    }

    const allGroupsClassname = cn('SearchResults_FilterOption', {
      'is-active': allActive,
      SearchResults_FilterOption_Expandable_AlignTop: !this.props.isPhone,
    })
    return (
      <FilterRow caption="Show results in:" reducedMargins>
        <a onClick={this._handleAllClick} className={allGroupsClassname}>
          Groups
        </a>
        {this.props.isPhone ? (
          <>
            {this._renderUserGroupFilters()}
            {additionalLink}
          </>
        ) : (
          this._renderGroupSelector()
        )}
      </FilterRow>
    )
  }

  _updateSelection: (value: Array<DropdownOption>) => void = (
    value: DropdownOption[],
  ) => {
    this.props.updateSearchParams({
      groups: value.map(v => v.value),
    })
  }

  _renderGroupSelector(): React.ReactNode {
    return (
      <ChannelSelector
        placeholder="Select groups"
        clearable={false}
        // @ts-expect-error
        channels={this.props.searchGroups}
        channelsIndexed={this.props.searchGroupsIndexed}
        // @ts-expect-error
        selectedChannels={this.props.groups}
        disabled={this.props.disabled}
        onChannelSelect={this._updateSelection}
        scrollContainer={this.props.scrollContainer}
      />
    )
  }

  _renderUserGroupFilters(): null | React.ReactNode[] {
    const { searchGroups, baseSearchGroups, showAllSearchGroups } = this.props
    if (!searchGroups || !baseSearchGroups) return null
    const groups = showAllSearchGroups ? searchGroups : baseSearchGroups
    return groups.map((group, index) => {
      const isActive =
        this.props.groups.indexOf(group.id) !== -1 ? ' is-active' : ''
      const name =
        group.internal_name && group.internal_name.length > 0
          ? group.internal_name
          : group.name
      return (
        <a
          onClick={() => this._handleGroupClick(group.id)}
          className={`SearchResults_FilterOption${isActive}`}
          key={index}
        >
          {name}
        </a>
      )
    })
  }
}
